import cn from 'bem-cn';

import { Icon, Stack } from '../../UI';
import { PromptInfoEditButtonProps } from './PromptInfoEditButton.types';

import './PromptInfoEditButton.scss';

const b = cn('prompt-info-edit-button');

export const PromptInfoEditButton = ({ onClick }: PromptInfoEditButtonProps) => {
    return (
        <button className={b()} onClick={onClick}>
            <Stack className={b('container')} alignItems="center" justifyContent="center">
                <Icon name="edit" size={24} />
            </Stack>
        </button>
    );
};
